import { render, staticRenderFns } from "./recyconcept.vue?vue&type=template&id=0839f975&scoped=true&"
import script from "./recyconcept.vue?vue&type=script&lang=js&"
export * from "./recyconcept.vue?vue&type=script&lang=js&"
import style0 from "./recyconcept.vue?vue&type=style&index=0&id=0839f975&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0839f975",
  null
  
)

export default component.exports